import { FilterOptionKeys, Goal, goalOtherID, ID } from '@griply/types';
import { buildGoalFilterOptionTree, GoalTreeNode } from '@griply/utils';
import { TFunction } from 'i18next';
import { Target } from 'shared/assets/icons';
import { Option } from 'shared/components/ui/custom-form-multi-select';
import { FilterOptionType, FilterSelectOption } from 'shared/types/filter';

export type Options = {
  t: TFunction;
  hideNoGoal?: boolean;
  taskCounts?: Map<ID, number>;
};

const toOption = ({ goal, children }: GoalTreeNode): Option => ({
  label: goal.name,
  value: goal.id,
  children: children.length ? children.map(toOption) : undefined,
});

export const createGoalFilter = (
  goals: Goal[],
  { t, hideNoGoal, taskCounts }: Options,
): FilterSelectOption[] => {
  if (!goals.length) {
    return [];
  }

  const groupedOptions = buildGoalFilterOptionTree(goals, taskCounts).map(
    toOption,
  );

  if (!groupedOptions.length) {
    return [];
  }

  return [
    {
      id: FilterOptionKeys.Goal,
      label: t('context-menus.filtering.task.filters.goals.title'),
      placeholder: t('general.labels.select'),
      icon: Target,
      type: FilterOptionType.MultiSelect,
      selectOptions: [
        ...groupedOptions,
        ...(hideNoGoal
          ? []
          : [
              {
                label: t('general.sections.goals.other.title'),
                value: goalOtherID,
              },
            ]),
      ],
      recursiveSelection: true,
      canReset: true,
      enableSearch: true,
    },
  ];
};
